<template>
  <el-form
    label-position="top"
    ref="estudiesForm"
    :model="estudiesForm"
    @submit.native.prevent="submit('estudiesForm', estudiesForm.estudies)"
  >
    <el-row :gutter="15">
      <el-col :span="3">
        <span>* Nivel</span>
      </el-col>
      <el-col :span="5">
        <span>* Institución</span>
      </el-col>
      <el-col :span="4">
        <span>* Carrera</span>
      </el-col>
      <el-col :span="7">
        <el-row :gutter="15">
          <el-col :span="12">
            <span>* Fecha inicio</span>
          </el-col>
          <el-col :span="12">
            <span>Fecha finalización</span>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="15" v-for="(item, index) in estudiesForm.estudies" :key="index">
      <el-col :span="3">
        <el-form-item :prop="`estudies.${index}.studyLevel`" :rules="rules.required">
          <el-select
            filterable
            clearable
            class="w-full"
            size="small"
            v-model="item.studyLevel"
            placeholder="Selecciona nivel"
          >
            <el-option
              v-for="level in levels"
              :key="level.id"
              :label="level.name"
              :value="level.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item :prop="`estudies.${index}.institution`" :rules="rules.required">
          <el-select
            filterable
            clearable
            class="w-full"
            size="small"
            v-model="item.institution"
            placeholder="Selecciona Institución"
          >
            <el-option
              v-for="institution in institutions"
              :key="institution.id"
              :label="institution.name"
              :value="institution.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item :prop="`estudies.${index}.career`" :rules="rules.required">
          <el-select
            filterable
            clearable
            class="w-full"
            size="small"
            v-model="item.career"
            placeholder="Selecciona la carrera"
          >
            <el-option
              v-for="career in careers"
              :key="career.id"
              :label="career.name"
              :value="career.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item :prop="`estudies.${index}.startDate`" :rules="rules.validateDateRequired">
              <el-input
                size="small"
                v-model="item.startDate"
                placeholder="DD/MM/YYYY"
                autocomplete="off"
                clearable
                prefix-icon="el-icon-date"
                v-mask="'##/##/####'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :prop="`estudies.${index}.endDate`" :rules="rules.validateDate">
              <el-input
                size="small"
                v-model="item.endDate"
                placeholder="DD/MM/YYYY"
                autocomplete="off"
                clearable
                prefix-icon="el-icon-date"
                v-mask="'##/##/####'"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="5">
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item>
              <el-checkbox
                style="margin-top: 5px;"
                career
                startDate
                endDate
                completed
                v-model="item.completed"
                label="Completo"
                border
                class="w-full"
                size="small"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-col :span="estudiesForm.estudies.length > (index + 1) ? 24 : 12">
                <el-form-item>
                  <el-button
                    style="margin-top: 5px;"
                    class="w-full"
                    type="danger"
                    size="small"
                    icon="el-icon-delete"
                    v-if="estudiesForm.estudies.length > 1"
                    @click="deleteStudy(index)"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :span="estudiesForm.estudies.length == 1 ? 24 : 12"
                v-if="estudiesForm.estudies.length == (index + 1) "
              >
                <el-form-item>
                  <el-button
                    class="w-full"
                    style="margin-top: 5px;"
                    type="success"
                    size="small"
                    icon="el-icon-plus"
                    @click="addNewStudy()"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :span="24" class="flex justify-end">
        <el-button size="small" @click="$emit('cancel')">Cancelar</el-button>
        <el-button size="small" type="primary" native-type="submit">Guardar</el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import dfn from "date-fns";

export default {
  name: "DialogStudies",
  props: ["employeeID", "values", "institutions", "careers", "levels"],
  data() {
    const validateDateRequired = (rule, value, callback) => {
      if (R.isNil(value) || R.isEmpty(value)) {
        callback(new Error("Este campo es requerido"));
        return false;
      }

      const [d, m, y] = value.split("/");
      const date = new Date(`${y}-${m}-${d}`);
      if (!dfn.isValid(date)) {
        callback(new Error("Formato fecha incorrecto."));
        return false;
      }
      callback();
    };
    const validateDate = (rule, value, callback) => {
      if (R.isNil(value) || R.isEmpty(value)) {
        callback();
        return false;
      }
      const [d, m, y] = value.split("/");
      const date = new Date(`${y}-${m}-${d}`);
      if (!dfn.isValid(date)) {
        callback(new Error("Formato fecha incorrecto."));
        return false;
      }
      callback();
    };
    return {
      estudiesForm: {
        estudies: [
          {
            studyLevel: "",
            institution: "",
            career: "",
            startDate: null,
            endDate: null,
            completed: false
          }
        ]
      },
      rules: {
        required: {
          required: true,
          message: "Campo requerido",
          trigger: "change"
        },
        validateDateRequired: [
          { validator: validateDateRequired, trigger: "blur" }
        ],
        validateDate: [{ validator: validateDate, trigger: "blur" }]
      }
    };
  },
  methods: {
    addNewStudy() {
      this.estudiesForm.estudies.push({
        studyLevel: "",
        institution: "",
        career: "",
        startDate: null,
        endDate: null,
        completed: false
      });
    },
    deleteStudy(index) {
      this.estudiesForm.estudies.splice(index, 1);
    },
    submit(formName, studies) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return false;
        }

        this.$confirm(
          "¿Estás seguro que deseas actualizar estos datos?",
          "Confirmación",
          {
            confirmButtonText: "Si, actualizar",
            cancelButtonText: "Cancelar",
            type: "warning"
          }
        )
          .then(() => {
            let estudios = "";
            for (const d of studies) {
              delete d.mask;
              const startDate = R.isNil(d.startDate)
                ? null
                : `"${d.startDate}"`;
              const endDate = R.isNil(d.endDate) ? null : `"${d.endDate}"`;
              estudios += `{
                studyLevel: "${d.studyLevel}",
                institution: "${d.institution}",
                career: "${d.career}",
                startDate: ${startDate},
                endDate: ${endDate},
                completed: ${d.completed}
              }`;
            }
            axios
              .post("/", {
                query: `mutation {
                  employeeManageStudies(
                    where: { id:"${this.employeeID}" },
                    studies: [${estudios}]
                  )
                  { id name1 lastname1 studies { id institution { name } career { name } studyLevel { name } } }
                }`
              })
              .then(res => {
                this.$notify({
                  title: "Éxito",
                  message: "Se ha actualizado la información correctamente.",
                  type: "success"
                });
                this.$emit("save", true);
              })
              .catch(console.log);
          })
          .catch((this.saving = false));
      });
    }
  },
  mounted() {
    if (!R.isEmpty(this.values)) {
      this.estudiesForm.estudies = this.values;
    }
  },
  updated() {
    if (!R.isEmpty(this.values)) {
      this.estudiesForm.estudies = this.values;
    }
  }
};
</script>
